import React, { useEffect } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { AsyncStorage, i18n, config } from '@formue-app/core';

import { GlobalFonts } from '@formue-app/web/src/fonts';
import { ResetStyles } from './reset';

import { OneTimePasswordPage } from './pages/OneTimePasswordPage';
import { IdentityPage } from './pages/IdentityPage';
import { CompletedIdentificationPage } from './pages/CompletedIdentificationPage';
import { ErrorPage } from './pages/ErrorPage';

const App = () => {
  const dispatch = useDispatch();

  document.title = `${config.title}`;

  useEffect(() => {
    const setLanguage = async () => {
      await AsyncStorage.setItem('language', i18n.locale);

      dispatch({
        type: 'SET_LANGUAGE',
        language: i18n.locale,
      });
    };

    setLanguage();
  }, [dispatch]);

  // Hack to reload language on change
  useSelector((state) => state.language);

  return (
    <>
      <ResetStyles />
      <GlobalFonts />
      <Router>
        <Routes>
          <Route path="/identity" element={<IdentityPage />} />
          <Route path="/completed" element={<CompletedIdentificationPage />} />
          <Route path="/error" element={<ErrorPage />} />
          {/* `/` was a catch-all under v5's <Switch>, so unknown paths must
              keep falling through to the one-time-password page. */}
          <Route path="/" element={<OneTimePasswordPage />} />
          <Route path="*" element={<OneTimePasswordPage />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
